/***
 * Created on 2024/5/13
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import MainLevelPanel from "./main_level_panel";
import {useTranslation} from "react-i18next";
import LangLevePanel from "./lang_leve_panel";

function HeaderSheet(props) {
    const { t } = useTranslation();
    const [openSecondLevel, setOpenSecondLevel] = React.useState('close');

     const toggleHeaderSheet = () => {
        const headerSheet = document.querySelector('.comp-sheet-wrapper');
        if (headerSheet.classList.contains('hide')) {
            headerSheet.classList.remove('hide');
        }
        else {
            headerSheet.classList.add('hide');
        }
    }

    return (
        <div className="comp-sheet sheet--large-detent" data-active-from="app-head__more">
            <div className="sheet">
                <div className="sheet-body">
                    <div className="multi-level-sheet-content" data-secondary-sheet-content={openSecondLevel}>
                        <MainLevelPanel toggleLang={setOpenSecondLevel} toggleSheet={toggleHeaderSheet}/>
                        <LangLevePanel toggleLang={setOpenSecondLevel}/>
                    </div>
                </div>
                <div className="sheet-footer">
                    <button className="q-btn q-btn--default q-btn--sheet btn-full-width" onClick={toggleHeaderSheet}>{t('@Close@')}</button>
                </div>
            </div>
        </div>
    );
}

export default HeaderSheet;